import {
    makeIndividualItems,
    makeInitialInfoItems
} from "../helpers/initial-info-items.jsx";

import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import ObservationBox from "../../../../../../components/observation-box/observation-box.jsx";

export default function InitialInfo({title, data, boName, printOptions}) {
    const individual = makeIndividualItems(data, printOptions);
    const initialData = makeInitialInfoItems(data, boName);

    const transcription = data?.dispatch?.attendance_transcription?.trim() ?? "";
    const attendantObservation = data?.dispatch?.attendance_observation?.trim() ?? "";
    const initialObservation = data?.dispatch?.dispatch_initialobservation?.trim() ?? "";

    const hasObservations =
        attendantObservation || initialObservation;

    return (
        <>
            <div className="px-5">
                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                    {title}
                </h2>
            </div>

            <div className="space-y-2">
                <InfoGrid
                    items={initialData}
                    columns={3}
                />

                <InfoGrid
                    items={individual}
                    columns={3}
                    className={
                        printOptions?.showRequesters
                            ? ""
                            : "print:hidden"
                    }
                />
            </div>

            {transcription && (
                <div className="px-5 mt-8">
                    <ObservationBox title="Transcrição do atendimento">
                        {transcription}
                    </ObservationBox>
                </div>
            )}

            {hasObservations && (
                <div className="flex gap-4 px-5 mt-8">
                    {attendantObservation && (
                        <ObservationBox title="Observação do atendente">
                            {attendantObservation}
                        </ObservationBox>
                    )}

                    {initialObservation && (
                        <ObservationBox title="Observação inicial">
                            {initialObservation}
                        </ObservationBox>
                    )}
                </div>
            )}
        </>
    );
}